<template>
  <div class="platform_fav margin-general">
    <div class="bg-"></div>
    <div class="container-slide">
      <div class="buttonsContainer" ref="buttonsContainer">
        <h2 class="">{{ $t( props.dynamicTitle || "market.platformFav.titleTable") }}</h2>
        <div class="btn-tabs">
          <button
            v-for="tab in tabs"
            :key="tab.name"
            class="buttonItem"
            :class="{ selected: selected === tab.value }"
            @click="selectTab(tab.value)"
          >
            {{ $t(tab.label) }}
          </button>
        </div>
        <a
          target="_blank"
          :href="getExternalUrl('/register/1/live-account')"
          class="second-button-small"
          role="button"
         rel="noopener noreferrer">
          {{ $t("market.platformFav.buttonTable") }}
        </a>
      </div>
      <swiper
        :spaceBetween="10"
        :slidesPerView="1.4"
        :slidesPerGroup="2"
        :loop="false"
        :navigation="true"
        :modules="modules"
        class="swiperTrading"
        :breakpoints="{
          '1200': {
            slidesPerView: 1,
            spaceBetween: 30,
            slidesPerGroup: 2,
          },
          '820': {
            slidesPerView: 1,
            spaceBetween: 30,
            slidesPerGroup: 1,
          },
          '770': {
            slidesPerView: 1,
            spaceBetween: 30,
            slidesPerGroup: 1,
          },
          '650': {
            slidesPerView: 1,
            spaceBetween: 15,
            slidesPerGroup: 1,
          },
          '570': {
            slidesPerView: 1,
            spaceBetween: 15,
            slidesPerGroup: 1,
          },
          '500': {
            slidesPerView: 1,
            spaceBetween: 15,
            slidesPerGroup: 1,
          },
          '376': {
            slidesPerView: 1,
            spaceBetween: 15,
            slidesPerGroup: 1,
          },
          '0': {
            slidesPerView: 1,
            spaceBetween: 15,
            slidesPerGroup: 1,
          },
        }"
      >
        <swiper-slide
          v-for="row in categories[selected]"
          :key="row.index"
          class="content-slide card"
        >
          <div class="content">
            <img
              :src="row.imgSrc"
              :alt="row.altImg"
              class="img-card"
              v-if="row.imgSrc"
            />
            <p class="title subtitle-4">{{ $t(row.title) }}</p>
            <div class="desc" :class="{ futures: selected === 'futures' }">
              <div class="item body-4">
                <ul>
                  <li
                    class="body-4"
                    v-for="item in row.items"
                    :key="item.index"
                  >
                    {{ $t(item.text) }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { useExternalUrl } from '@/composables/useExternalUrl';

const { getExternalUrl } = useExternalUrl();

const props = defineProps({
  dynamicTitle: {
    type: String,
    default: ''
  }
});

const selected = ref("forex");
const tabs = [
  { value: "forex", label: "tradingAccounts.categories1" },
  { value: "stocks", label: "tradingAccounts.categories2" },
  /* { value: "futures", label: "tradingAccounts.categories3" }, */
];
const selectedButtonIndex = ref(0);
const borderStyle = ref({});
const buttonsContainer = ref(null); // Define the ref here
const categories = {
  forex: [
    /* {
      imgSrc: "/images/favorite-1.svg",
      altImg: "MT4 Logo",
      title: "market.platformFav.mt4",
      items: [
        { text: "market.platformFav.card8Item1" },
        { text: "market.platformFav.card8Item2" },
        { text: "market.platformFav.card8Item3" },
        { text: "market.platformFav.card8Item4" },
        { text: "market.platformFav.card8Item5" },
      ],
    }, */
    {
      imgSrc: "/images/favorite-2.svg",
      altImg: "MT5 Logo",
      title: "market.platformFav.mt5",
      items: [
        { text: "market.platformFav.card1Item1" },
        { text: "market.platformFav.card1Item2" },
        { text: "market.platformFav.card1Item3" },
        { text: "market.platformFav.card1Item4" },
        { text: "market.platformFav.card1Item5" },
      ],
    },
    /* {
      imgSrc: "/images/favorite-3.svg",
      altImg: "cTrader Logo",
      title: "market.platformFav.ctrader",
      items: [
        { text: "market.platformFav.card9Item1" },
        { text: "market.platformFav.card9Item2" },
        { text: "market.platformFav.card9Item3" },
        { text: "market.platformFav.card9Item4" },
        { text: "market.platformFav.card9Item5" },
      ],
    }, */
  ],
  /* futures: [
    {
      imgSrc: "/images/favorite-2.svg",
      altImg: "MT5 Logo",
      title: "market.platformFav.mt5",
      items: [
        { text: "market.platformFav.card1Item1" },
        { text: "market.platformFav.card1Item2" },
        { text: "market.platformFav.card1Item3" },
        { text: "market.platformFav.card1Item4" },
        { text: "market.platformFav.card1Item5" },
      ],
    },
    {
      imgSrc: "/images/favorite-9.svg",
      altImg: "CQG",
      title: "market.platformFav.cqg",
      items: [
        { text: "market.platformFav.card2Item1" },
        { text: "market.platformFav.card2Item2" },
        { text: "market.platformFav.card2Item3" },
        { text: "market.platformFav.card2Item4" },
        { text: "market.platformFav.card2Item5", hiddenInLocales: ['es-mx'] },
      ],
    },
  ], */
  stocks: [
    {
      imgSrc: "/images/favorite-2.svg",
      altImg: "MT5 Logo",
      title: "market.platformFav.mt5",
      items: [
        { text: "market.platformFav.card1Item1" },
        { text: "market.platformFav.card1Item2" },
        { text: "market.platformFav.card1Item3" },
        { text: "market.platformFav.card1Item4" },
        { text: "market.platformFav.card1Item5" },
      ],
    },
    /* {
      imgSrc: "/images/favorite-4.svg",
      altImg: "Sterling Trader Logo",
      title: "market.platformFav.sterling",
      items: [
        { text: "market.platformFav.card3Item1" },
        { text: "market.platformFav.card3Item2" },
        { text: "market.platformFav.card3Item3" },
        { text: "market.platformFav.card3Item4" },
        { text: "market.platformFav.card3Item5" },
      ],
    },
    {
      imgSrc: "/images/favorite-5.svg",
      altImg: "Lightspeed Trader Logo",
      title: "market.platformFav.lightspeed",
      items: [
        { text: "market.platformFav.card4Item1" },
        { text: "market.platformFav.card4Item2" },
        { text: "market.platformFav.card4Item3" },
        { text: "market.platformFav.card4Item4" },
        { text: "market.platformFav.card4Item5" },
      ],
    },
    {
      imgSrc: "/images/favorite-6.svg",
      altImg: "Takion Logo",
      title: "market.platformFav.takion",
      items: [
        { text: "market.platformFav.card5Item1" },
        { text: "market.platformFav.card5Item2" },
        { text: "market.platformFav.card5Item3" },
        { text: "market.platformFav.card5Item4" },
        { text: "market.platformFav.card5Item5" },
      ],
    },
    {
      imgSrc: "/images/favorite-7.svg",
      altImg: "Das Logo",
      title: "market.platformFav.das",
      items: [
        { text: "market.platformFav.card6Item1" },
        { text: "market.platformFav.card6Item2" },
        { text: "market.platformFav.card6Item3" },
        { text: "market.platformFav.card6Item4" },
        { text: "market.platformFav.card6Item5" },
      ],
    },
    {
      imgSrc: "/images/favorite-8.svg",
      altImg: "API/FIX",
      title: "market.platformFav.api/fix",
      items: [
        { text: "market.platformFav.card7Item1" },
        { text: "market.platformFav.card7Item2" },
        { text: "market.platformFav.card7Item3" },
        { text: "market.platformFav.card7Item4" },
        { text: "market.platformFav.card7Item5" },
      ],
    }, */
  ],
};
const modules = [Pagination, Autoplay, Navigation];

const selectTab = (tabName) => {
  const newIndex = tabs.findIndex((tab) => tab.value === tabName);
  if (newIndex !== -1) {
    selected.value = tabName;
  }
  selectedButtonIndex.value = newIndex;
  updateBorderBottomStyle();
};

const initializeBorderBottomStyle = () => {
  if (
    buttonsContainer.value &&
    buttonsContainer.value.children[selectedButtonIndex.value]
  ) {
    const button = buttonsContainer.value.children[selectedButtonIndex.value];
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
};

const updateBorderBottomStyle = () => {
  if (
    buttonsContainer.value &&
    buttonsContainer.value.children[selectedButtonIndex.value]
  ) {
    const button = buttonsContainer.value.children[selectedButtonIndex.value];
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
};

onMounted(() => {
  initializeBorderBottomStyle();
  selected.value = "forex";
});

watch(selectedButtonIndex, () => {
  updateBorderBottomStyle();
});
</script>